export const CALCULATION_PROGRESS_RECEIVED = 'progress/CALCULATION_PROGRESS_RECEIVED';
export const CLEAR_CALCULATION_PROGRESS_STATE = 'progress/CLEAR_CALCULATION_PROGRESS_STATE';

export const IMPORT_DATA_PROGRESS_RECEIVED = 'progress/IMPORT_DATA_PROGRESS_RECEIVED';
export const CLEAR_IMPORT_PROGRESS_STATE = 'progress/CLEAR_IMPORT_PROGRESS_STATE';
export const CANCELED_IMPORT_PROGRESS_STATE = 'progress/CANCELED_IMPORT_PROGRESS_STATE';

export const IMPORT_INSTRUMENTS_PROGRESS_RECEIVED = 'progress/IMPORT_INSTRUMENTS_PROGRESS_RECEIVED';
export const CLEAR_IMPORT_INSTRUMENTS_PROGRESS_STATE = 'progress/CLEAR_IMPORT_INSTRUMENTS_PROGRESS_STATE';
export const CANCELED_IMPORT_INSTRUMENTS_PROGRESS_STATE = 'progress/CANCELED_IMPORT_INSTRUMENTS_PROGRESS_STATE';



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/progress/progress.action.const.ts